var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-switcher",class:_vm.themeBg},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab.value,class:{
      tab: true,
      'tab-active': tab.value == _vm.value && _vm.themeBg !== 'dark',
      'tab-active-dark': _vm.themeBg == 'dark' && tab.value == _vm.value,
    },on:{"click":function($event){return _vm.$emit('input', tab.value)}}},[(_vm.htmlRender)?_c('span',{staticClass:"qrw-button-text",domProps:{"innerHTML":_vm._s(tab.text)}}):_c('span',{staticClass:"qrw-button-text"},[_vm._v(" "+_vm._s(tab.text))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }